interface Options {
  words?: number;
  chars?: number;
}

export function shorten(text = '', options: Options = {}) {
  if (options.chars && text.length > options.chars) {
    return appendDots(text.substring(0, options.chars - 2));
  }
  const words = text.split(/ +/);
  if (words.length <= (options.words ?? 15)) {
    return text;
  }
  return appendDots(words.slice(0, (options.words ?? 15)).join(' '));
}

function appendDots(text: string) {
  return text.replace(/[,. ]+$/, '') + '...';
}
